const awsConfiguration = {
  region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_yjhdNMP2C",
  ClientId: "6qbdk2fotguu5faap8hf3kns2n"
}
export default awsConfiguration
